<header class="transparent position-relative" style="z-index: 5">
  <div class="container">
    <div class="row">
      <div class="col-md-2">
        <div class="logo"><a routerLink="/"><img src="assets/images/logo.png" alt="logo"></a></div>
      </div>
      <div class="col-md-9">
        <ul class="menu">
          <li><a routerLink="/">Главная</a></li>
          <li class="children">
            <a href="javascript:void(0)">Тарифы</a>
            <ul class="sub-menu">
              <li class="text-center"><a href="javascript:void(0)" routerLink="pages/tariffs/home-inet" routerLinkActive="active">Домашний интернет</a></li>
              <li  class="text-center"><a href="javascript:void(0)" routerLink="pages/tariffs/home-inet-tv" routerLinkActive="active">Домашний интернет + ТВ</a></li>
            </ul>
          </li>
          <li><a href="javascript:void(0)" routerLink="/contacts">Контакты</a></li>
          <li><a href="javascript:void(0)" routerLink="/other">Дополнительно</a></li>
          <li><a href="javascript:void(0)" routerLinkActive="active" routerLink="/info">Информация</a></li>
          <!--<li class="children">
            <a href="#">Hosting</a>
            <ul class="sub-menu">
              <li><a href="service-page.html">Service page 1</a></li>
              <li><a href="service-page-light.html">Service page 2</a></li>
              <li><a href="service-page-dark.html">Service page 3</a></li>
              <li><a href="service-page-images.html">Service page 4</a></li>
            </ul>&lt;!&ndash;sub-menu&ndash;&gt;
          </li>&lt;!&ndash;children&ndash;&gt;-->
          <!--<li class="children">
            <a href="user-interface.html">Pages</a>
            <ul class="sub-menu">
              <li><a href="404.html">404 Page</a></li>
              <li><a href="order.html">Order</a></li>
              <li><a href="user-interface.html">User Interface</a></li>
            </ul>&lt;!&ndash;sub-menu&ndash;&gt;
          </li>-->
          <!--<li><a href="blog-list.html">Blog</a></li>
          <li><a href="contact.html">Contact Us</a></li>-->
        </ul>
      </div>
      <div class="col-md-1">
        <div class="button-header">
          <a href="https://sberbank.com/sms/shpa/?cs=1677784429888&psh=p&did=1714644426531000310" target="_blank" class="custom-btn">Оплатить</a>
        </div>
      </div>
    </div>
  </div>
  <div class="mobile-block">
    <div class="logo-mobile"><a routerLink="/"><img src="assets/images/logo.png" alt="logo"></a></div>
    <div class="button-header button-header-mobile" style="margin-right: 80px; margin-top: 10px;">
      <a href="https://sberbank.com/sms/shpa/?cs=1677784429888&psh=p&did=1714644426531000310" target="_blank" class="custom-btn">Оплатить</a>
    </div>
    <a href="javascript:void(0)" class="mobile-menu-btn"><span></span></a>
    <div class="mobile-menu">
      <div class="inside">
        <div class="logo">
          <a href="javascript:void(0)"><img src="assets/images/logo.png" alt="logo"></a>
        </div><!--logo-->
        <ul class="menu panel-group" id="accordion" aria-multiselectable="true">
          <!--<li><a href="index.html">Главная</a></li>
          <li><a href="about.html">About Us</a></li>-->
          <li><a routerLink="/" (click)="closeMenu()">Главная</a></li>
          <li class="children">
            <a href="javascript:void(0)">Тарифы</a>
            <ul class="sub-menu">
              <li class="text-center"><a href="javascript:void(0)" routerLink="pages/tariffs/home-inet" (click)="closeMenu()" routerLinkActive="active">Домашний интернет</a></li>
              <li  class="text-center"><a href="javascript:void(0)" routerLink="pages/tariffs/home-inet-tv" (click)="closeMenu()" routerLinkActive="active">Домашний интернет + ТВ</a></li>
            </ul>
          </li>
          <li><a href="javascript:void(0)" (click)="closeMenu()" routerLink="/contacts">Контакты</a></li>
          <li><a href="javascript:void(0)" (click)="closeMenu()" routerLink="/other">Дополнительно</a></li>
          <li><a href="javascript:void(0)" (click)="closeMenu()" routerLink="/info">Информация</a></li>
        </ul><!--menu-->
        <!--<div class="button-header">
          <a href="login.html" class="custom-btn login">Login</a>
          <a href="#" class="custom-btn">Sign Up</a>
        </div>&lt;!&ndash;button-header&ndash;&gt;-->
      </div><!--inside-->
    </div><!--mobile-menu-->
  </div>
</header>
